import React, { useState } from "react";
import { logToSentry } from "../../config/Sentry";
import { useDispatch } from "react-redux";
import { Box, Button, FormControl, TextField } from "@mui/material/";
import { strings } from "../i18n";
import actions from "../../Store/actions";
import makeStyles from "@mui/styles/makeStyles";
import DatePicker from "react-datepicker";
import styles from "./styles";
import datePickerStyles from "../css/datePickerStyles";

type Props = {
    onSubmit: Function
};

/**
 * Audit Group Form Component
 */

/** Date Picker Config s*/
const datePickerConfig = {
    format: "MMMM d, yyyy h:mm aa",
    minDate: new Date(),
    timeIntervals: 30,
    filterPassedTime: (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    }
};

export default ({ onSubmit }: Props) => {
    const [data, setData] = useState({
        closedDate: null,
        endDate: null,
        name: "",
        startDate: new Date()
    });

    const classes = makeStyles(styles)();
    const calStyles = makeStyles(datePickerStyles)();
    const dispatch = useDispatch();

    const CalContainer = ({ children }) => {
        return (
            <Box className={calStyles.customDatePickerStyle}>
                <div className={classes.datePickerContainer}>{children}</div>
            </Box>
        );
    };

    const handleChange = (name) => (event) => {
        setData({ ...data, [name]: event.target.value });
    };

    const handleDateChange = (name, date) => {
        setData({ ...data, [name]: date });
    };

    const onSave = async () => {
        try {
            let res = null;
            res = await dispatch(actions.auditGroups.create.postRequest(data));
            onSubmit && onSubmit(res.auditGroup);
        } catch (error) {
            console.error(error);
            logToSentry("On audit group post:", { error });
            dispatch(actions.toast.create.error(strings("errors.auditGroupPost")));
        }
    };

    const onValidate = () => data.endDate > data.startDate && data.name;

    return (
        <>
            <FormControl fullWidth margin="normal" variant="standard">
                <TextField
                    variant="standard"
                    label={strings("name")}
                    onChange={handleChange("name")}
                    value={data.name}
                />
            </FormControl>
            <FormControl fullWidth margin="normal">
                <Box className={calStyles.customDatePickerStyle}>
                    <DatePicker
                        popperContainer={CalContainer}
                        showTimeSelect
                        minDate={datePickerConfig.minDate}
                        filterTime={datePickerConfig.filterPassedTime}
                        placeholderText={strings("startDate")}
                        timeIntervals={datePickerConfig.timeIntervals}
                        className={classes.datePickerStyle}
                        wrapperClassName={calStyles.datePickerWrapper}
                        portalId="startDate-portal"
                        dateFormat={datePickerConfig.format}
                        value={data.startDate}
                        selected={data.startDate}
                        onChange={(dt) => {
                            handleDateChange("startDate", dt);
                        }}
                    />
                </Box>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <Box className={calStyles.customDatePickerStyle}>
                    <DatePicker
                        popperContainer={CalContainer}
                        showTimeSelect
                        placeholderText={strings("endDate")}
                        timeIntervals={datePickerConfig.timeIntervals}
                        filterTime={(time) => {
                            const currentDate = new Date(data.startDate);
                            const selectedDate = new Date(time);
                            return (
                                currentDate.getTime() < selectedDate.getTime()
                            );
                        }}
                        className={classes.datePickerStyle}
                        wrapperClassName={calStyles.datePickerWrapper}
                        minDate={data.startDate}
                        portalId="endDate-portal"
                        dateFormat={datePickerConfig.format}
                        value={
                            data.endDate < data.startDate
                                ? data.startDate
                                : data.endDate
                        }
                        selected={
                            data.endDate < data.startDate
                                ? data.startDate
                                : data.endDate
                        }
                        startDate={data.startDate}
                        onChange={(dt) => {
                            handleDateChange("endDate", dt);
                        }}
                    />
                </Box>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <Button
                    disabled={!onValidate()}
                    onClick={onSave}
                    size="large"
                    variant="outlined"
                >
                    {strings("save")}
                </Button>
            </FormControl>
        </>
    );
};
